import moment from 'moment';

const BOOKINGS_LIST_PAGE_FILTERS = [
    {
        key: 'confirmationCode',
        label: 'Confirmation code',
        type: 'text'
    },
    {
        key: 'bookingId',
        label: 'Reservation ID',
        type: 'text'
    },
    {
        key: 'vendor',
        label: 'Vendor name',
        type: 'vendorautocomplete'
    },
    {
        key: 'agent',
        label: 'Agent name',
        type: 'agentautocomplete'
    },
    {
        key: 'guest',
        label: 'Guest name',
        type: 'guestautocomplete'
    },
    {
        key: 'activity',
        label: 'Activity name',
        type: 'activityautocomplete'
    },
    {
        key: 'checkInDate',
        rangeKeys: ['checkInDate', 'checkOutDate'],
        label: 'Activity date',
        type: 'daterange'
    },
    {
        key: 'fromCreateDate',
        rangeKeys: ['fromCreateDate', 'toCreateDate'],
        label: 'Booking date',
        type: 'daterange'
    },
    {
        key: 'startDateTime',
        label: 'Start date and time',
        type: 'datetime'
    },
    {
        key: 'paymentType',
        label: 'Payment Method',
        type: 'paymentmethodautocomplete'
    },
    {
        key: 'statusList',
        label: 'Booking status',
        type: 'statuslistautocomplete'
    },
    {
        key: 'fromModifiedDate',
        label: 'Last modified',
        rangeKeys: ['fromModifiedDate', 'toModifiedDate'],
        type: 'daterange'
    }
];

function getFilterFromUrl(urlSearchPart) {
    const searchParams = new URLSearchParams(urlSearchPart.trim() !== '' ? urlSearchPart : '');
    const checkInDate =
        searchParams.get('datefrom') !== null && moment(searchParams.get('datefrom')).isValid()
            ? moment(searchParams.get('datefrom'))
            : null;
    const checkOutDate =
        searchParams.get('dateto') !== null && moment(searchParams.get('dateto')).isValid()
            ? moment(searchParams.get('dateto'))
            : null;
    const fromCreateDate = moment(searchParams.get('fromcreatedate')).isValid()
        ? moment(searchParams.get('fromcreatedate'))
        : null;
    const toCreateDate = moment(searchParams.get('tocreatedate')).isValid()
        ? moment(searchParams.get('tocreatedate'))
        : null;
    const startDateTime = moment(searchParams.get('startdatetime')).isValid()
        ? moment(searchParams.get('startdatetime'))
        : null;

    const fromModifiedDate = moment(searchParams.get('frommodifieddate')).isValid()
        ? moment(searchParams.get('frommodifieddate'))
        : null;

    const toModifiedDate = moment(searchParams.get('tomodifieddate')).isValid()
        ? moment(searchParams.get('tomodifieddate'))
        : null;

    return {
        checkInDate,
        checkOutDate,
        fromCreateDate,
        toCreateDate,
        startDateTime,
        confirmationCode: searchParams.get('confirmationCode') || '',
        vendor: searchParams.get('vendor') || null,
        agent: searchParams.get('agent') || null,
        bookingId: !Number.isNaN(parseInt(searchParams.get('bookingId'), 10))
            ? parseInt(searchParams.get('bookingId'), 10)
            : '',
        activity: searchParams.get('activity') || null,
        guest: searchParams.get('guest') || null,
        paymentType: searchParams.get('paymentType') || null,
        fromModifiedDate,
        toModifiedDate,
        statusList: (searchParams.get('statusList') || '').split(',').filter(Boolean) || []
    };
}

function getUrlFromFilter(filter) {
    const search = new URLSearchParams();
    if (filter.checkInDate) {
        search.append('datefrom', filter.checkInDate.format('YYYY-MM-DD'));
    }
    if (filter.checkOutDate) {
        search.append('dateto', filter.checkOutDate.format('YYYY-MM-DD'));
    }
    if (filter.fromCreateDate) {
        search.append('fromcreatedate', filter.fromCreateDate.format('YYYY-MM-DD'));
    }
    if (filter.toCreateDate) {
        search.append('tocreatedate', filter.toCreateDate.format('YYYY-MM-DD'));
    }
    if (filter.confirmationCode) {
        search.append('confirmationCode', filter.confirmationCode);
    }
    if (filter.bookingId) {
        search.append('bookingId', filter.bookingId);
    }
    if (filter.vendor) {
        search.append('vendor', filter.vendor);
    }
    if (filter.activity) {
        search.append('activity', filter.activity);
    }
    if (filter.agent) {
        search.append('agent', filter.agent);
    }
    if (filter.guest) {
        search.append('guest', filter.guest);
    }
    if (filter.startDateTime) {
        search.append('startdatetime', filter.startDateTime.format('YYYY-MM-DDTHH:mm'));
    }
    if (filter.paymentType) {
        search.append('paymentType', filter.paymentType);
    }
    if (filter.fromModifiedDate) {
        search.append('frommodifieddate', filter.fromModifiedDate.format('YYYY-MM-DD'));
    }
    if (filter.toModifiedDate) {
        search.append('tomodifieddate', filter.toModifiedDate.format('YYYY-MM-DD'));
    }
    if (Array.isArray(filter.statusList) && filter.statusList.length) {
        search.append('statusList', filter.statusList.join(','));
    }
    const searchString = search.toString();
    return `?${searchString}`;
}

export { BOOKINGS_LIST_PAGE_FILTERS, getFilterFromUrl, getUrlFromFilter };
